// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"xfdCkx"};